var map = {
	"./agenda-full.png": 9569,
	"./agenda-thumbnail.png": 6512,
	"./agenda/board.png": 3758,
	"./agenda/dashboard.png": 8110,
	"./agenda/homepage.png": 8192,
	"./agenda/kanban.png": 9077,
	"./ergogami-full.png": 8070,
	"./ergogami-thumbnail.png": 489,
	"./ergogami/assembled.png": 7103,
	"./ergogami/both-versions.png": 8706,
	"./ergogami/pcb-both.png": 9698,
	"./ergogami/pcb.png": 5368,
	"./meme-generator-full.png": 4201,
	"./meme-generator-thumbnail.png": 3384,
	"./meme-generator/homepage.png": 1176,
	"./meme-generator/i18n.png": 884,
	"./meme-generator/merge-conflicts.png": 5400,
	"./meme-generator/new-framework.png": 8323,
	"./minesweeper-full.png": 735,
	"./minesweeper-thumbnail.png": 7902,
	"./minesweeper/beginner.png": 9716,
	"./minesweeper/expert.png": 8782,
	"./minesweeper/medium.png": 3963,
	"./minesweeper/won.png": 3136,
	"./touch-nums-full.png": 3738,
	"./touch-nums-thumbnail.png": 2877,
	"./touch-nums/easy.png": 213,
	"./touch-nums/hard.png": 7040,
	"./touch-nums/homepage.png": 851,
	"./touch-nums/medium.png": 5802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5300;